
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getPostList } from '@/api/post';
import InfiniteLoading from 'vue-infinite-loading';

@Component({
  components: {
    InfiniteLoading,
  },
})

export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private shortListQuery: any = {
    boardUid: 'e418321d-654c-4611-bfe0-19dadb9917a0',
    page: 0,
    size: 10,
    searchType: '',
    searchValue: '',
  }

  private listQuery = {
    page: 0,
    size: 10,
    searchType: 'title',
    searchValue: '',
    sort: 'status',
  }

  private handleSearch() {
    this.postList = [];
    this.listQuery.page = 0;
    this.isNoMore = false;
    this.getPostList();
  }

  private isNoMore = false;

  private loading = true;

  private postList = [];

  private getPostList() {
    this.loading = true;
    getPostList(this.shortListQuery).then((res) => {
      this.postList = res.data.content;
      this.loading = false;
    });
  }

  private shortsNavigateToDetail(short: any) {
    let inputValue = short.dataList?.[0]?.inputValue;

    if (inputValue) {
      if (inputValue.startsWith('instagram://')) {
        const match = inputValue.match(/shortcode=([^&]+)/);
        if (match && match[1]) {
          // instagram:// 딥링크를 범용 웹 주소(App Link / Universal Link)로 강제 치환
          // 모바일 기기에 인스타 앱이 깔려있으면 자동으로 네이티브 앱이 열리고, 앱이 없으면 웹으로 안전하게 열림
          inputValue = `https://www.instagram.com/reel/${match[1]}/`;
        }
      }

      window.open(inputValue, '_blank');
    }
  }
}
